module.exports = require("node-forge");


//////////////////
// WEBPACK FOOTER
// external "node-forge"
// module id = 4
// module chunks = 0